import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { MatStepperModule } from '@angular/material/stepper';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { AngularWebStorageModule } from 'angular-web-storage';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule, MAT_DATE_LOCALE } from '@angular/material/core';
@NgModule({
    imports: [
        MatButtonModule,
        MatCheckboxModule,
        MatStepperModule,

        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatRadioModule,
        MatCardModule,
        AngularWebStorageModule,
        MatTooltipModule,
        MatMenuModule,
        MatAutocompleteModule,
        MatIconModule,
        MatPaginatorModule,
        MatDatepickerModule,
        MatNativeDateModule
      ],
    exports: [
        MatButtonModule,
        MatCheckboxModule,
        MatStepperModule,
  
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatRadioModule,
        MatCardModule,
        MatTableModule,
        MatTooltipModule,
        MatMenuModule,
        MatAutocompleteModule,
        MatIconModule,
        MatPaginatorModule,
        MatDatepickerModule,
        MatNativeDateModule
      ],
      providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' }
      ],
})
export class MaterialModule { }
